module.exports = __webpack_public_path__ + "img/bgc.706af41c.png";